import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { setStoredLogo, hasStoredLogo } from "../../utils/logo";
import { useDispatch, useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
import { FiAlignJustify, FiAlignRight, FiHome } from "react-icons/fi";
const Header = ({ flag, Header, toggleMenu, menuClick }) => {
  const { userData } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [initials, setInitials] = useState("");
  const [pathName, setPathName] = useState(
    window.location.pathname.split("/")[1]
  );
  const [siteDetails, setSiteDetails] = useState([]);

  useEffect(() => {
    console.log("userDAta", userData);
    if (userData && userData !== "default" && userData.length > 0) {
      // Extract the first letters of first_name and last_name
      const firstNameInitial = userData[0].first_name.charAt(0).toUpperCase();
      const lastNameInitial = userData[0].last_name.charAt(0).toUpperCase();

      // Set the initials in the state
      setInitials(firstNameInitial + lastNameInitial);
      // } else if (pathName !== "careers" && userData === "default") {
      //   window.location.href = "/employerLogin";
      // }
    } else if (pathName !== "careers") {
      // window.location.href = "/employerLogin";
    }
  }, [userData]);

  useEffect(() => {
    if (flag) {
      const firstNameInitial = flag[0]?.charAt(0).toUpperCase();
      const lastNameInitial = flag[1]?.charAt(0).toUpperCase();
      setInitials(firstNameInitial + lastNameInitial);
    }
  }, [flag]);

  useEffect(() => {
    if (!hasStoredLogo()) {
      getSiteDetails();
    }
  }, []);

  const getSiteDetails = (siteIdOrUrl) => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    const webUrl = webUrlMatch ? webUrlMatch[1] : "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("responseLogin", response);
      if (response.success === "1") {
        setSiteDetails(response.dataSet);
        setStoredLogo(response.dataSet[0]?.company_logo);
      } else {
        console.log("Error while fetching site details");
        return false;
      }
    });
  };
  const handleLogout = () => {
    // Tell the backend to end the server side session, then clear locally
    // regardless of whether that call succeeded.
    backendApi({ functionName: "logout" })
      .catch(() => {})
      .finally(() => {
        localStorage.clear();
        window.location.href = "/";
      });
  };

  const [showDrop, setShowDrop] = useState(false);

  const refDrop = useRef(null);
  const dropdownShow = () => {
    setShowDrop(!showDrop);
  };
  const handleClickOutside = (event) => {
    if (refDrop.current && !refDrop.current.contains(event.target)) {
      setShowDrop(false);
    }
  };

  useEffect(() => {
    if (showDrop) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDrop]);

  return (
    <>
      <ul className="header_nav">
        <li className="">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
              <li
                className="breadcrumb-item text-white d-flex align-items-center"
                aria-current="page"
              >
                <FiHome className="me-1" />
                <a href="/dashboard/dashboardMain" className="text-white breadcrumb_page opacity-75">
                  Home
                </a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                {Header}
              </li>
            </ol>
          </nav>
        </li>
        <li className="ms-auto">
          <ul class="nav gap-3">
            <li
              className="header-item"
              onClick={() => dropdownShow()}
              ref={refDrop}
            >
              <div className="user_btn">
                <span className="userLogined">{initials}</span>
              </div>
              {pathName !== "careers" && (
                <ul className={`header-drop ${showDrop ? "show" : ""}`}>
                  <li
                    className="header-drop-li"
                    onClick={() => nav("/dashboard/profile")}
                  >
                    Profile
                  </li>
                  <li
                    className="header-drop-li"
                    onClick={() =>
                      nav("/changePassword", {
                        state: {
                          type: "user",
                        },
                      })
                    }
                  >
                    Change Password
                  </li>
                  <li className="header-drop-li" onClick={handleLogout}>
                    Logout
                  </li>
                </ul>
              )}
            </li>
            <li className="header-item nav-item d-xl-none ps-2 d-flex align-items-center">
              {menuClick ? (
                <FiAlignRight
                  style={{ fontSize: "20px" }}
                  onClick={() => toggleMenu()}
                />
              ) : (
                <FiAlignJustify
                  style={{ fontSize: "20px" }}
                  onClick={() => toggleMenu()}
                />
              )}
            </li>
          </ul>
        </li>
      </ul>
    </>
  );
};

export default Header;
